export default __webpack_public_path__ + "static/kaktus-70df0b4ff9d75bcf7cb6887f18f2fc2f.svg";